import * as React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { PageWrap } from '../layouts';
import { H1, H3 } from '../typography';
import { color } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

const ErrorMessageContainer = styled.div<StyledSystemProps>`
  top: 0;
  left: 0;
  right: 0;
  ${color};
  bottom: 0;
  display: flex;
  z-index: ${theme.zIndex[12]};
  position: fixed;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & h1 {
    margin: 0;
    font-size: 206px;
    text-align: center;
  }
  & p {
    font-size: 16px;
    text-align: center;
  }
`;

export default () => (
  <PageWrap justifyContent="center" alignItems="center">
    <ErrorMessageContainer bg="paleGrey">
      <H1 color="putty">404</H1>
      <H3 fontWeight={300}>Whoops! Looks like there's nothing to see here.</H3>
    </ErrorMessageContainer>
    <Helmet title="404" />
  </PageWrap>
);



// WEBPACK FOOTER //
// ./src/navigation/NoMatch.tsx